'use client';

import type { BlockEmailComposeProps } from '@/types/blocks';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

const DEFAULT_RECIPIENT = 'sollismembership@sollishealth.com';
const DEFAULT_SUBJECT = 'Elevated Health Care';
const DEFAULT_BODY =
  'I would like to connect to better understand membership benefits and pricing.';

export function EmailCompose(props: BlockEmailComposeProps) {
  const {
    recipient = DEFAULT_RECIPIENT,
    subject = DEFAULT_SUBJECT,
    body = DEFAULT_BODY,
    redirectAfterTimeout,
    redirectDelay,
  } = props;

  const router = useRouter();

  useEffect(() => {
    // Build mailto URL with encoded parameters
    const mailtoUrl = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Open the user's email client
    window.location.href = mailtoUrl;

    // If both redirect URL and delay are configured, redirect after the delay
    if (redirectAfterTimeout && redirectDelay !== undefined) {
      const timeoutId = setTimeout(() => {
        router.push(redirectAfterTimeout);
      }, redirectDelay * 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [recipient, subject, body, redirectAfterTimeout, redirectDelay, router]);

  return null;
}
